$(function() {
  // placeholder polyfill
  var placeholderShown = function() {
    $(this)[$(this).val() ? 'removeClass' : 'addClass']('placeholder-shown');
  };

  var placeholders = $('[placeholder]');
  placeholders.each(function() {
    placeholderShown.call(this, placeholderShown);
  });

  $('[placeholder]').on('keyup change input', placeholderShown);
});